export default __webpack_public_path__ + "static/leader_4-40d1479979008ab240d90e6d9a64ba1b.png";